let hasUnknownError = false

const hasPermissionsQuery = () => {
  return (
    typeof navigator !== 'undefined' &&
    navigator.permissions &&
    navigator.permissions.query
  )
}

if (hasPermissionsQuery()) {
  navigator.permissions.query({ name: 'microphone' }).catch(function () {
    hasUnknownError = true
  })
}

const isRecordingAble = function () {
  return (
    !hasUnknownError &&
    hasPermissionsQuery() &&
    typeof window.MediaRecorder === 'function'
  )
}

export default {
  isRecordingAble
}
